<template>
  <footer class="global-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-left">
          <img src="../assets/logo-white.png" alt="" class="footer-logo">
          <p class="footer-desc">全流程电子招投标服务平台</p>
        </div>

        <div class="footer-right">
          <div class="footer-links">
            <a href="#" class="link">网站声明</a>
            <span class="divider">|</span>
            <a href="#" class="link">联系我们</a>
            <span class="divider">|</span>
            <a href="#" class="link">隐私安全</a>
            <span class="divider">|</span>
            <a href="#" class="link">免责声明</a>
          </div>
          <p class="copyright">版权所有：上海慧标领航项目管理有限公司</p>
          <p class="beian">
            备案号：
            <!-- <a href="#" class="link">沪公网安备 31010402000870号</a> -->
            <span class="link ml-2">沪ICP备2025144820号-1</span>
          </p>
          <p class="hotline">统一客服热线：021-62597292</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GlobalFooter',
};
</script>

<style lang="less" scoped>
p{
  margin-bottom: 0;
}
.global-footer {
  background-color: #5B617D; // bg-[#4d5669]
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    height: 168px;
    display: flex;
    justify-content: space-between;
    align-items: center;


    .footer-left {
      text-align: left;

      .footer-logo {
        width: 128px;
        height: auto;
        margin-bottom: 12px;
      }

      .footer-desc {
        color: #fff; 
        font-size: 17px;
      }
    }

    .footer-right {
      text-align: left;
      font-size: 18px;
      color: #fff;

      .footer-links {
        margin-bottom: 2px;

        .link {
          color: white;
          text-decoration: none;
          transition: color 0.3s;

          &:hover {
            color: white;
          }
        }

        .divider {
          margin: 0 16px; 
          color: white;

        }
      }

      .copyright {
        margin-bottom: 2px;

      }

      .beian {
        margin-bottom: 2px;

        .link {
          color: #fff;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }

          &.ml-2 {
            margin-left: 8px;
          }
        }
      }

      .hotline {
        color: #fff;

      }
    }
  }
}
</style>
